/**
 @ngdoc directive
 @name xmsSmartTable

 @description
 The template inside the table always has to use ngModel.<br />
 You need to specify ng-repeat which will be used as it is (so any optimization like 'track by' is up to you).<br />
 You always need to return numberOfPages in your JSON.

 @param {Object} options ie options="{search:true|false}" search (true by default) - you can remove search field in ther the table
 @param {Object} options ie options="{appendPath:true|false}" appendPath (true by default) - turn off append path so that createLink can be used
 @param {Object} options ie options="{searchTerms:'tagOwner','tagOwnerOU'}" searchTerms - for linking auto complete (xmsAutocomplete) search fields
 @param {Object} options ie options="{addAjaxData:{Object}}" addAjaxData - additional ajax data for ajax url request (POST) ie. options="{addAjaxData:{level:5201}}"
 @param {number} refresh ie. refresh="formModel.smartTableRefresh" refresh the table whenever this variable changes (ie. is incremented)
 @param {String} searchPlaceholder ie. search-placeholder="Filter List By Account Name"
 */
(function() {
    'use strict';

    var xmsSmartTable = function($compile, $timeout, $sce, ajaxCall, errorMsgFactory){

        return({
            restrict: "A",
            scope: true, // it cannot be isolated scope as it will break multiactionModel
            compile: compile
        });


        function compile( tElement, tAttributes ) {

            // store the content of the directive in the variable then remove it
            var htmlContent = tElement.html();
            tElement.html(''); // remove


            return function postLink(scope, element, attrs) {

                var options = {};
                var addAjaxData = '';
                var xmsPredicateObject = {};
                var searchPlaceholder;

                function setFromAttrValue(attrKeyName, defaultValue){
                    var attrValue = attrs[attrKeyName];
                    return angular.isDefined(attrValue) ? attrValue : defaultValue;
                }


                (function initialize(){
                    if(angular.isDefined(attrs.options)){
                        options = scope.$eval(attrs.options);
                    }

                    if(angular.isDefined(attrs.xmsPredicateObject)){
                        xmsPredicateObject = scope.$eval(attrs.xmsPredicateObject);
                    }
                    searchPlaceholder = setFromAttrValue('searchPlaceholder', 'Filter list...');

                    scope.appendPath = options.appendPath;
                    scope.searchTerms = options.searchTerms;

                    if( angular.isDefined(options.addAjaxData) ){
                        angular.forEach(options.addAjaxData, function(val, key){
                            addAjaxData += '&'+key+'='+val;
                        });
                    }


                    var $html = $('<div />',{ html:htmlContent }); // for easier manipulation

                    var table = $html.find('table'),
                        tbody = $html.find('tbody');

                    table
                        .attr('st-pipe',"callServer")
                        .attr('smart-table-refresh', angular.isDefined(attrs.refresh) ? attrs.refresh : '') ;

                    var colNum = table.find('tr:first-child+tr').find('th').length;

                    var filterHtml = '';
                    var downloadhtml = '';
                    if(options.search !== false){
                        filterHtml = [
                            '<div style="float:left; width:220px;">',
                            '<div class="form-group">',
                            '<input st-search="" st-delay="1000" class="form-control" placeholder="',
                            searchPlaceholder,
                            '" type="text" ng-model="formModel.smartTableSearch" style="font-weight: normal" />',
                            '</div>',
                            '</div>'].join('');
                        if(attrs.downloadUrl) {
                          downloadhtml = ' <button type="button" class="btn btn-link"  ' +
                            'ng-if="formModel.smartTableSearch!=null" ng-click="this.downloadFiltered();">' +
                            '<i class="glyphicon glyphicon-download-alt" style="margin-right:3px;"></i>Download</button>';
                        }
                    }

                    var tickCountHtml = '';
                    if(options.destroyData == false){
                        tickCountHtml = '<span class="mr-3" style="float: left; line-height: 2.7rem;"><span class="mr-2">{{((multiactionModel.tickall | findAllValueFilter:true) | toArray).length}} selected</span>' +
                            '<untick-all ng-if="((multiactionModel.tickall | findAllValueFilter:true) | toArray).length > 0" ticked="multiactionModel.tickall"></untick-all>';
                    }

                    var paginationHtml = '</span><div st-pagination="" st-items-by-page="15"></div>';

                    table.find('thead tr:first-child th').append(tickCountHtml).append(filterHtml).append(downloadhtml).append(paginationHtml);
                    table.find('tfoot tr:first-child td').append(tickCountHtml).append(filterHtml).append(paginationHtml);

                    var loadingRow = [
                        '<tr ng-if="isLoading" class="loading-row">',
                        '<td colspan="'+colNum+'" class="text-center" style="text-align: center;"><span style="margin-bottom:0;" class="loading-spinner">Loading ...</span></td>',
                        '</tr>'].join('');
                    tbody.append(loadingRow).prepend(loadingRow);
                    tbody.find('[ng-repeat]').attr('ng-style',"isLoading? {'opacity':'0.25'} : {}");

                    $timeout(function(){
                        element.append( $compile( $html.html() )(scope) );
                    });
                })(); // () - executes on declaration

                var ajaxRequest;

                scope.callServer = function(tableState) {

                    scope.isLoading = true;
                    // scope.multiactionModel = {};

                    var pagination = tableState.pagination;

                    var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
                    var number = pagination.number || 15;  // Number of entries showed per page.
                    var numberOfPages = pagination.numberOfPages;

                    var sort = angular.isDefined(tableState.sort.predicate) ? 'sort='+tableState.sort.predicate : '';
                    var sortOrder = tableState.sort.reverse ? 'desc' : 'asc';

                    var search = '';
                    if(angular.isDefined(attrs.xmsPredicateObject)){
                        tableState.search.predicateObject = xmsPredicateObject;
                    }
                    if (angular.isDefined(tableState.search.predicateObject)) {
                        angular.forEach(tableState.search.predicateObject, function(val, key) {
                            if (key == "$"){
                                search += '&search=' + encodeURIComponent(val);
                            } else {
                                search += '&' + key + '=' + encodeURIComponent(val);
                            }
                        });


                    }
                    // this is done especially for filtering with xmsAutocomplete
                    if (angular.isDefined(scope.ngModel)){
                        angular.forEach(scope.searchTerms, function(val){
                            if(angular.isDefined(scope.ngModel[val])){
                                search += '&' + val + '=' + scope.ngModel[val];
                            }
                        });
                    }
                    // abort previous request if it's still being processed
                    // (otherwise it could be returned even later than the current request!)
                    if( angular.isDefined(ajaxRequest) && ajaxRequest.abort!==angular.noop ){
                        console.info('Early new request - aborting previous request.');
                        ajaxRequest.abort(); // cancel previous request
                    }

                    // var totalCount = angular.isDefined(tableState.pagination.totalItemCount) ? '&totalCount='+tableState.pagination.totalItemCount : '';

                    // request
                    ajaxRequest = ajaxCall.getData(
                        (angular.isDefined(options.appendPath) && (options.appendPath=='false' || options.appendPath==false)) ? attrs.url : WEBAPP_PATH + attrs.url,
                        sort+'&order='+sortOrder+'&offset='+start+'&max='+number+search+'&numberOfPages='+numberOfPages+'&smartTable=true'+addAjaxData
                    );
                    ajaxRequest.then(
                        function(result){
                            scope.isLoading                     = false;
                            scope.ngModel                       = result.data;
                            tableState.pagination.numberOfPages = result.data.numberOfPages;
                            /*if(angular.isDefined(result.data.total)){
                                tableState.pagination.totalItemCount = result.data.totalCount;
                            }*/
                        },
                        function(result){
                            // scope.isLoading    = false;
                            scope.loadingError = $sce.trustAsHtml( errorMsgFactory.connectionError(result) );
                            console.log('xmsSmartTable error?');
                            console.log(errorMsgFactory.connectionError(result));
                        }
                    );
                };

                scope.downloadFiltered = function(){
                  location.href = attrs.downloadUrl + "&searchTerm="+scope.formModel.smartTableSearch;
                };

            }
        }
    }
    xmsSmartTable.$inject = ['$compile', '$timeout', '$sce', 'ajaxCall', 'errorMsgFactory'];
    angular.module('app').directive('xmsSmartTable', xmsSmartTable);



    // to refresh the listing table just use smartTableRefresh() function ie. ng-click="smartTableRefresh()" or on-success="smartTableRefresh()" with ajax-helper
    var smartTableRefresh = function(){
        return {
            require: 'stTable',
            restrict: "A",
            link:function(scope, elem, attrs, stTable){

                scope.smartTableRefresh = function(){
                    var tableState = stTable.tableState();
                    tableState.pagination.start = 0;
                    stTable.pipe(tableState);
                }

                // refresh table on variable change
                scope.$watch(
                    function(){
                        return scope.$eval(attrs.smartTableRefresh);
                    },
                    function(newVal, oldVal){
                        if(newVal!=oldVal){
                            scope.smartTableRefresh();
                        }
                    }
                );

            }
        }
    }
    smartTableRefresh.$inject = [];
    angular.module('app').directive('smartTableRefresh', smartTableRefresh);

}());
